export default "data:image/gif;base64,R0lGODlhEgAMAPEAAP///+0cJCQdRAAAACH5BAAAAAAALAAAAAASAAwAAAIXjI+py+APo5xU2Iuz3rz7r1HiKDLmaRYAOw=="